<template>
  <div class="content-container flex-column">
    <!-- <TheLoader :small="true" :active="$store.getters.isFormLoading"/> -->

    <section class="content large-padding fixed-width small scrollnav">
      <form @submit.prevent="handleSubmit">
        <div class="scroll-section">
          <fieldset class="card">
            <div class="grid-x grid-padding-x">
              <TheSelectInput
                v-model="form.avdeling"
                containerClassName="cell medium-9"
                label="Velg avdeling" name="avdeling"
                required
                v-validate="'required'"
                :items="instillinger.avdeling"
                :disabled="$store.getters.isFormLoading"
              />
            </div>

            <template v-if="selectedAvdeling === 0">
              <TheAutoCompleteInputButton
                v-model.trim="auksjonInputValue"
                name="Auksjon"
                maxlength="10"
                containerClassName="cell medium-9"
                v-validate="'required|max:10'"
                required
                :placeholder="'Velg auksjon'"
                :label="'Tilhørende auksjon'"
                :onInputCallback="onAuksjonSearchInput"
                :onSelectCallback="onAuksjonSearchSelected"
                :debounce="1500"
                :minquery="2">
                <div slot="item" slot-scope="props">
                  <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
                  <span v-if="props.item.Auksjon_dato">
                    ({{ props.item.Auksjon_dato | avantidate }})
                  </span>
                </div>
              </TheAutoCompleteInputButton>
            </template>

            <template v-if="selectedAvdeling === 1 || selectedAvdeling === 2">
              <div class="grid-x grid-padding-x">
                <div class="cell medium-6">
                  <label for="fra">Auksjon dato, f.o.m: *</label>
                  <div class="input-container">
                    <b-datepicker
                      @input="(date) => formatDate(date, 'fra')"
                      :max-date="max_fra"
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      v-model="form.fra"
                      required
                      name="fra"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="fra"
                      id="fra">
                    </b-datepicker>
                    <span class="glyph">
                      <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
                    </span>
                  </div>
                </div>
                <div class="cell medium-6">
                  <label for="til">Auksjon dato, t.o.m: *</label>
                  <div class="input-container">
                    <b-datepicker
                      @input="(date) => formatDate(date, 'til')"
                      :min-date="min_til"
                      :max-date="max_til"
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      v-model="form.til"
                      required
                      name="til"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="til"
                      id="til">
                    </b-datepicker>
                    <span class="glyph">
                      <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
                    </span>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="selectedAvdeling !== null">
              <TheAutoCompleteInputButton
                v-model.trim="kundeInputValue"
                name="Kunde"
                maxlength="10"
                containerClassName="cell medium-9"
                :placeholder="'Velg kunde'"
                :label="'Tilhørende kunde: ' + (this.form.kundenr ? this.form.kundenr : '-')"
                :onInputCallback="onKundeSearchInput"
                :onSelectCallback="onKundeSearchSelected"
                :minquery="2">
                <div slot="item" slot-scope="props">
                  <span v-if="props.item.Bedrift"><strong>{{props.item.Kundenr}}</strong>, {{props.item.FirmaNavn}}</span>
                  <span v-else-if="props.item.full_name"><strong>{{props.item.Kundenr}}</strong>, {{props.item.full_name}}</span>
                  <span v-else><strong>{{props.item.Kundenr}}</strong></span>
                </div>
              </TheAutoCompleteInputButton>
            </template>
          </fieldset>
        </div>

        <div class="scroll-section" v-if="selectedAvdeling !== null">
          <fieldset class="card">
            <div class="grid-x grid-padding-x">
              <div class="cell"><h2>Innstillinger</h2></div>
              <div class="cell">
                <div class="input-container checkbox">
                  <input type="checkbox" name="onlyNotSent" id="onlyNotSent" v-model="form.onlyNotSent">
                  <label for="onlyNotSent">Skriv ut kun ikke tidligere sendte bekreftelsebrev.</label>
                  <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                </div>
              </div>

              <div class="cell medium-12" style="margin-bottom: 1.2rem; border-top: 1px solid #bbb;"></div>

              <div class="cell">
                <div class="input-container checkbox">
                  <input type="radio" name="avsender" id="avsender-0" v-model="avsender" v-bind:value="0">
                  <label for="avsender-0">Sett kundeservice@blomqvist.no som avsender.</label>
                  <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                </div>
                <div class="input-container checkbox">
                  <input type="radio" name="avsender" id="avsender-1" v-model="avsender" v-bind:value="1">
                  <label for="avsender-1">Sett Knut.Forsberg@blomqvist.no som avsender.</label>
                  <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                </div>
                <div class="input-container checkbox">
                  <input type="radio" name="avsender" id="avsender-2" v-model="avsender" v-bind:value="2">
                  <label for="avsender-2">Sett annen avsender.</label>
                  <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                </div>
              </div>

              <div class="cell medium-12">&nbsp;</div>

              <TheTextInput v-model.trim="form.from_email" :disabled="avsender !== 2" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender e-post'" :placeholder="'Avsender e-post…'" name="from_email" v-validate="'email'"/>
              <TheTextInput v-model.trim="form.from_name" containerClassName="cell medium-6" :label="'Avsender navn'" :placeholder="'Avsender navn…'" name="from_name"/>
              <TheTextInput v-model.trim="form.email_subject" containerClassName="cell medium-12" :label="'Emne / Overskrift (default: auksjonsbeskrivelse)'" :placeholder="'Emne / Overskrift…'" name="email_subject"/>
            </div>

            <!-- <div class="grid-x grid-padding-x">
              <div class="cell" v-if="selectedAvdeling !== null">
                <button v-if="isSubmittable" class="button primary">Oprett</button>
                <button v-else-if="$store.getters.isFormProcessing" class="button primary loading" @click.prevent="() => {}">Oppretter...<span class="loader-spinner"></span></button>
                <button v-else class="button primary" @click.prevent="() => {}" disabled>Oprett</button>
              </div>
            </div> -->
          </fieldset>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import TheAutoCompleteInputButton from '../../Inputs/TheAutoCompleteInputButton'
import InstillingerService from '@/services/InstillingerService'
import BekreftelsebrevService from '@/services/BekreftelsebrevService'
import AuksjonService from '@/services/AuksjonService'
import KundeService from '@/services/KundeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'

export default {
  name: 'BekreftelsebrevOpprett',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInputButton
  },
  data () {
    return {
      form: {
        onlyNotSent: true,
        from_name: null,
        from_email: null,
        avdeling: null,
        auksjon: null,
        kundenr: null,
        fra: new Date(moment().subtract(1, 'days').format('YYYY-MM-DD')),
        til: new Date(moment().subtract(1, 'days').format('YYYY-MM-DD'))
      },
      instillinger: {
        avdeling: []
      },
      auksjonInputValue: null,
      kundeInputValue: null,
      max_fra: new Date(moment().format('YYYY-MM-DD')),
      max_til: new Date(moment().format('YYYY-MM-DD')),
      avsender: null,
      avsenderList: [
        { from_name: 'Blomqvist', from_email: 'kundeservice@blomqvist.no' },
        { from_name: 'Knut Forsberg', from_email: 'Knut.Forsberg@blomqvist.no' },
        { from_name: '', from_email: '' }
      ]
    }
  },
  created () {
    bus.$off('save-bekreftelsebrev')
  },
  mounted () {
    bus.$on('save-bekreftelsebrev', () => this.handleSubmit())
    this.init()
  },
  watch: {
    'form.fra': function () {
      const diff = moment(this.form.fra).diff(moment(this.form.til))

      if (diff >= 0) {
        this.form.til = new Date(moment(this.form.fra).format('YYYY-MM-DD'))
      }
    },
    auksjonInputValue: function (newVal) {
      if (newVal === null || newVal === '') {
        this.form.auksjon = null
      }
    },
    kundeInputValue: function (newVal) {
      if (newVal === null || newVal === '') {
        this.form.kundenr = null
      }
    },
    avsender: function (newVal) {
      if (newVal !== null && newVal !== undefined) {
        try {
          let item = this.avsenderList[newVal]
          this.form.from_name = item.from_name
          this.form.from_email = item.from_email

          this.$validator.reset()
        } catch (e) {
          this.form.from_name = null
          this.form.from_email = null
        }
      }
    },
    isSubmittable: function (newVal) {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('onSubmitStatusChange', newVal ? 'submittable' : null)
      }
    }
  },
  computed: {
    min_til: function () {
      return new Date(Date.parse(moment(this.form.fra).subtract(1, 'days').format('YYYY-MM-DD')))
    },
    selectedAvdeling: function () {
      if (this.form.avdeling !== null) {
        return parseInt(this.form.avdeling)
      }

      return null
    },
    isSubmittable: function () {
      if (!this.$store.getters.isFormSubmittable) {
        return false
      }

      if (this.selectedAvdeling !== null) {
        if (this.selectedAvdeling === 0) {
          return this.form.auksjon !== null
        }

        if (this.selectedAvdeling === 1) {
          return this.form.fra !== null && this.form.til !== null
        }

        if (this.selectedAvdeling === 2) {
          return this.form.fra !== null && this.form.til !== null
        }
      }

      return false
    }
  },
  methods: {
    formatDate: function (date, key) {
      if (this.form.hasOwnProperty(key)) {
        this.form[key] = new Date(moment(date).format('YYYY-MM-DD'))
      }
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.avdeling)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.form.auksjon = item.Auksjon ? item.Auksjon : null
        this.auksjonInputValue = item.Auksjon ? item.Auksjon : null
      }
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      if (item) {
        this.kundeInputValue = (item.Bedrift ? item.FirmaNavn : item.full_name) || item.Kundenr
        this.form.kundenr = item.Kundenr
      } else {
        this.kundeInputValue = null
        this.form.kundenr = null
      }
    },
    init: function () {
      this.setFormLoading(true)

      // Set default avsender
      this.avsender = 0

      // Load avdeling instillinger
      this.instillinger.avdeling.unshift({key: this.form.avdeling, val: 'Laster...'})

      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.instillinger.avdeling = response.data
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    handleSubmit: function () {
      if (!this.isSubmittable) {
        return
      }

      this.$emit('onSubmitStatusChange', 'processing')
      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil i skjemaet')
          } else {
            let post = {}

            if (this.form.onlyNotSent) {
              post.sent = 'F'
            }

            if (this.selectedAvdeling === 0) {
              post.avdeling = 0
              post.auksjon = this.form.auksjon
            } else if (this.selectedAvdeling === 1) {
              post.avdeling = 1
              post.fra = moment(this.form.fra).format('YYYY-MM-DD')
              post.til = moment(this.form.til).format('YYYY-MM-DD')
            } else if (this.selectedAvdeling === 2) {
              post.avdeling = 2
              post.fra = moment(this.form.fra).format('YYYY-MM-DD')
              post.til = moment(this.form.til).format('YYYY-MM-DD')
            }

            if (this.form.kundenr) {
              post.kundenr = this.form.kundenr
            }

            post.from_email = this.form.from_email || null
            post.from_name = this.form.from_name || null
            post.email_subject = this.form.email_subject || null

            // console.log(post)
            // this.$emit('onSubmitStatusChange', 'submittable')
            // this.setFormProcessing(false)

            BekreftelsebrevService.build(post)
              .then((response) => {
                let text = []
                const manual = response.data.manual || 0
                const queued = response.data.queued || 0

                if (manual === 1) {
                  text.push('1 ny bekreftelsebrev som må printes')
                } else {
                  text.push(`${manual} nye bekreftelsebrev som må printes`)
                }

                if (queued === 1) {
                  text.push('1 ny bekreftelsebrev blev lagt til i e-post kø')
                } else {
                  text.push(`${queued} nye bekreftelsebrev blev lagt til i e-post kø`)
                }

                this.$helpers.showSuccessAlert('Suksess', text.join('<br>'), true)
              })
              .catch(error => {
                console.log('Error', error)
                // Put API errors into the error container
                // this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Feil', 'Vennligst prøv igjen')
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.$emit('onSubmitStatusChange', 'submittable')
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/BekreftelsebrevNy.vue